export default {"src":"/_next/static/media/icon_compare_hovered.7d810c05.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};